import React from 'react';
import { IconProps } from '../IconProps';
const SvgChevronBold = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 13 12" fill="none" {...props}>
    <path
      d="M6.232 9.25a.744.744 0 01-.53-.22l-4.25-4.25a.75.75 0 111.061-1.061l3.72 3.72 3.72-3.72a.75.75 0 011.061 1.061l-4.25 4.25a.748.748 0 01-.53.22h-.002z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgChevronBold;
